import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import { toast } from 'react-toastify'
import { useState } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { colors } from '~constants/colorsPallete'

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
}

export default function ModalDownloadInvoices({
  open,
  handleClose,
  selectedIds,
  onConfirm,
}: {
  open: boolean
  handleClose: VoidFunction
  selectedIds: string[]
  onConfirm?: (ids: string[]) => Promise<void>
}) {
  const [loading, setLoading] = useState(false)

  const handleConfirmDownload = async () => {
    setLoading(true)
    try {
      if (onConfirm) {
        await onConfirm(selectedIds)
      }

      toast.success(`Download de ${selectedIds.length} nota(s) fiscal(is) iniciado com sucesso!`)
      handleClose()
    } catch (error) {
      console.error('Error downloading invoices:', error)
      toast.error('Erro ao fazer download das notas fiscais. Tente novamente.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-download-title"
      aria-describedby="modal-download-description"
    >
      <Box sx={style}>
        <Typography id="modal-download-title" variant="h6" component="h2">
          Confirmar Download
        </Typography>
        <Typography id="modal-download-description" sx={{ mt: 2 }}>
          Você tem certeza que deseja fazer o download de <strong>{selectedIds.length}</strong> nota(s) fiscal(is)?
        </Typography>
        <Typography sx={{ mt: 1, fontSize: '0.875rem', color: 'text.secondary' }}>
          Esta ação irá baixar um arquivo ZIP contendo todas as notas fiscais selecionadas.
        </Typography>
        <div
          style={{
            marginTop: '20px',
            justifyContent: 'flex-end',
            display: 'flex',
          }}
        >
          <Button onClick={handleClose} sx={{ mr: 2, color: colors['gray.500'] }} disabled={loading}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmDownload}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
            sx={{
              backgroundColor: colors['green.default'],
              '&:hover': {
                backgroundColor: colors['green.600'],
              },
            }}
          >
            {loading ? 'Baixando...' : 'Confirmar Download'}
          </Button>
        </div>
      </Box>
    </Modal>
  )
}
